<template>
  <v-menu transition="slide-y-transition" bottom offset-y>
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex align-center" v-bind="attrs" v-on="on">
        <!--        <div class="avatar__image" />-->
        <div class="pl-3 pr-2">
          <div class="avatarDropdown__title">
            {{ user ? user.firstName : "" }} {{ user ? user.lastName : "" }}
          </div>
          <div class="body-1 font-weight-bold navy--text text--lighten-1">
            Nastavení {{ attrs.value }}
          </div>
        </div>
        <v-icon
          class="avatarDropdown__arrow"
          :style="{ transform: attrs.value ? 'rotate(180deg)' : 'none' }"
        >
          mdi-menu-down
        </v-icon>
      </div>
    </template>
    <v-list class="settingsList">
      <v-list-item
        v-for="(item, index) in menuItems"
        :key="index"
        @click="onItemClick(item)"
      >
        <v-list-item-title>
          {{ item.text }}
        </v-list-item-title>
      </v-list-item>
      <v-divider class="my-2" />
      <v-list-item class="c-list-item--small">
        <v-list-item-title class="body-1">
          Všeobecné obchodní podmínky
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="c-list-item--small">
        <v-list-item-title class="body-1">
          Ochrana osobních údajů
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="c-list-item--small">
        <v-list-item-title class="body-1">
          Kontakt
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { call, get } from "vuex-pathify"
import router from "../../../router"

export default {
  data() {
    return {
      menuItems: [
        { text: "Nastavení", link: "/settings" },
        { text: "Platební údaje", link: "/settings/billing" },
        { text: "Odhlásit se", onClick: this.logout },
      ],
    }
  },
  computed: {
    ...get("auth", ["user"]),
  },
  methods: {
    ...call("auth", ["logout"]),
    onItemClick(item) {
      if (item.link) {
        router.push(item.link)
      } else if (item.onClick) {
        item.onClick.call()
      }
    },
  },
}
</script>

<style scoped>
.avatar__image {
  border-radius: 7px;
  width: 34px;
  height: 34px;
  object-fit: cover;
  background-color: #bbb;
  border: none;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.c-list-item--small {
  min-height: 20px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
</style>
